import styled from 'styled-components'

const FooterButton = ({ onComplete, totalSceneNum, currSceneNum, isValid, children }) => {
  const bgColor = isValid ? '#ffcf19' : '#D8D8D8'
  const textColor = isValid ? '#121212' : '#989898'

  return (
    <>
      <FooterSection>
        <Button bgColor={bgColor} textColor={textColor} onClick={onComplete}>
          {children}
        </Button>
      </FooterSection>
      <Spacer />
    </>
  )
}

const FooterSection = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: calc(100vw * (73 / 375));
`

const Button = styled.button`
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (26 / 375));
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
  text-align: center;
  padding: calc(100vw * (24 / 375)) 0;
  width: 100%;
  height: 100%;
`

const Spacer = styled.div`
  height: calc(100vw * (73 / 375));
`

export default FooterButton
